import {
  AllProductsEnum,
  CalculatedProducts,
  isProductNotLikeBOH,
  isProductLikeBOH,
  PricingStructuresEnum,
} from "../Components/QuoteRequest/Content";
import { Content } from "./Content";

const Validation = (
  values,
  opportunityType,
  visibility,
  isConsultingITDevShowCalculate
) => {
  let errors = {};
  /*COMMON FIELDS VALIDATION - QUOTE DETAILS FORM SECTION*/ //START
  
  //   Total potential headcount outside what is requested to be quoted Validation
  values.totalPotentialHeadCountOutside = values.totalPotentialHeadCountOutside
    ?.toString()
    .trim();
  if (!values.totalPotentialHeadCountOutside) {
    errors.numbercount = Content.HEADCOUNT_REQUIRED;
  }

  // existingPartneredClientInfo Validation
  values.existingPartneredClientInfo = values.existingPartneredClientInfo
    ?.toString()
    .trim();
  if (!values.existingPartneredClientInfo && opportunityType === "NEW") {
    errors.existingPartneredClientInfo = Content.PAST_QUOTE_REQUIRED;
  }
  // currentRateEffectiveOn Validation
  values.currentRateEffectiveOn = values.currentRateEffectiveOn
    ?.toString()
    .trim();
  if (!values.currentRateEffectiveOn && opportunityType === "RENEWAL") {
    errors.currentRateEffectiveOn = Content.PAST_QUOTE_REQUIRED;
  }
  // Past quotes Validation
  values.pastQuotes = values.pastQuotes?.toString().trim();
  if (!values.pastQuotes && opportunityType !== "RENEWAL") {
    errors.pastquotes = Content.PAST_QUOTE_REQUIRED;
  }

  // Current Utilization with another vendor (If Applicable) Validation
  values.currentUtilizationWithOtherVendors =
    values.currentUtilizationWithOtherVendors?.toString().trim();
  if (
    !values.currentUtilizationWithOtherVendors &&
    opportunityType !== "RENEWAL"
  ) {
    errors.currentutlization = Content.CURRENT_UTLIZATION_REQUIRED;
  }

  //   Date Picker Validation
  if (!values.deadline) {
    errors.deadlineDate = Content.JOURNEY_DATE_REQUIRED;
  }

  //   Number of RAM(s) validation
  values.noOfRAMs = values.noOfRAMs?.toString().trim();
  if (!values.noOfRAMs) {
    errors.numberram = Content.NUMBER_RAM_REQUIRED;
  }

  // SAM Pricing Recommendation and assumptions Validation
  values.samPriceRecommendAssumption = values.samPriceRecommendAssumption
    ?.toString()
    .trim();
  if (!values.samPriceRecommendAssumption) {
    errors.sampricing = Content.SAM_PRICING_REQUIRED;
  }

  // Options Validation
  if (!values.productId) {
    errors.selectedOption = Content.SELECT_OPTION;
  } else {
    // Discount Validation
    if (isNaN(values.discount)) {
      errors.discount = Content.UTLIZATION_NUMBER_VALID;
    }
    //Validation Other Products (if Product is not calculated in CPQ)
    if (!Object.values(CalculatedProducts).includes(values.productId)) {
      values.additionalNotes = values.additionalNotes?.toString().trim();
      if (!values.additionalNotes) {
        errors.additionalNotes = Content.ADDITIONAL_NOTES_REQUIRED;
      }
      //HOURS
      if (
        !values.hours &&
        values.productId ===
          AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS
      ) {
        errors.hours = Content.HOURS_REQUIRED;
      } else if (
        !/^[1-9][0-9]*(\.[0-9]+)?$/.test(values.hours) &&
        values.productId ===
          AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS
      ) {
        errors.hours = Content.VALID_HOURS;
      }

      if (
          !values.hours &&
          values.productId === AllProductsEnum.RETURNTOWORK_CANCERCARECOMPASS &&
          values.pricingStructureId ===
            PricingStructuresEnum.FLATFEE_BANKOFCASES
        ) {
          errors.hours = Content.HOURS_REQUIRED;
        }

      //PRICING STRUCTRE OPTION VALIDATION
      if (!values.pricingStructureId) {
        errors.pricingOption = Content.SELECT_OPTION;
      }
    }
    //Validation Calculated Products (if Product is calculated in CPQ)
    //Exception : 1.Hours, Additional Notes required only for BOH/GWQ/NPRTW
    // 2. Product Variation not required for BOH/GWQ/NPRTW
    else {
      //PRODUCT VARIATION
      if (
        !values.productVariationId &&
        isProductNotLikeBOH(values.productId) &&
        values.productId !== AllProductsEnum.ENHANCEDLEGALSERVICES &&
        values.productId !== AllProductsEnum.ENHANCEDFINANCIALSERVICES
      ) {
        errors.productVariationOption = Content.SELECT_OPTION;
      } else {
        //SESSION
        values.sessions = values.sessions?.toString().trim();
        if (
          !values.sessions &&
          visibility?.SESSION &&
          values.productId !==
            AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS
        ) {
          errors.session = Content.SESSION_REQUIRED;
        } else if (
          !/^[1-9][0-9]*$/.test(values.sessions) &&
          visibility?.SESSION
        ) {
          errors.session = Content.VALID_SESSION;
        } else {
          if (values.sessions?.length > 25 && visibility?.SESSION) {
            errors.session = Content.SESSION_LIMIT;
          }
        }
        //AM HOURS
        values.amHours = values.amHours?.toString().trim();
        if (
          !values.amHours &&
          visibility?.AMHOURS &&
          opportunityType === "RENEWAL"
        ) {
          errors.amHours = Content.AM_OURS_REQUIRED;
        }
        values.additionalNotes = values.additionalNotes?.toString().trim();
        //ADDITIONAL NOTES
        if (
          !values.additionalNotes &&
          visibility?.ADDITIONALNOTES &&
          isProductLikeBOH(values.productId)
        ) {
          errors.additionalNotes = Content.ADDITIONAL_NOTES_REQUIRED;
        }
        //HOURS
        if (isConsultingITDevShowCalculate) {
          if (
            !values.hours &&
            visibility?.HOURS &&
            isProductLikeBOH(values.productId)
          ) {
            errors.hours = Content.HOURS_REQUIRED;
          } else if (
            !/^[0-9][0-9]*$/.test(values.hours) &&
            visibility?.HOURS &&
            values.hours <= 0 &&
            isProductLikeBOH(values.productId)
          ) {
            errors.hours = Content.VALID_HOURS;
          }
        }        

        //UTILIZATION VALIDATION
        values.utilization = values.utilization?.toString().trim();
        if (!values.utilization && visibility?.UTILIZATION) {
          errors.utilization = Content.UTLIZATION_NUMBER_REQUIRED;
        } else if (isNaN(values.utilization) && visibility?.UTILIZATION) {
          errors.utilization = Content.UTLIZATION_NUMBER_VALID;
        } else {
          const utilizationNumber = parseFloat(values.utilization);
          if (utilizationNumber <= 0 && visibility?.UTILIZATION) {
            errors.utilization = Content.UTLIZATION_NUMBER_GREATER;
          }
        }
        //PRICING STRUCTRE OPTION VALIDATION
        if (!values.pricingStructureId) {
          errors.pricingOption = Content.SELECT_OPTION;
        }
      }
    }
  }
  return errors;
};

export default Validation;
